<template>
    <div class="p-0">
        <div class="font-color-171717">
    
    
            <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
                <!-- <CCol sm="12" class="mb-3">
                    <div class="text-right mb-3">
                        <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleAddVoucher">
                            <span class="ml-3 mr-3">{{ buttonVoucher }}</span>
                        </CButton>
                    </div>
                </CCol> -->
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isListVoucher">
                    <div class="text-right">
                        <CButton type="button" class="custom-border-purple text-white mr-3 mt-3" @click="toggleAddVoucher">
                            <span class="ml-3 mr-3">{{ buttonVoucher }}</span>
                        </CButton>
                    </div>
                       
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3 mb-4">Voucher</h3>
                            <!-- <p class="custom-18px-400 text-center m-2">Subscribe to view the details and watch the interview videos of up to 25 candidates</p> -->
    
                        </CCol>
                        <template v-if="Busy == true">
                          <div class="container text-center">
                            <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                          </div>
                        </template>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CInput type="text" placeholder="Search..." v-model="searchQuery" @keyup.enter="filterList" />
                                </CCol>
                                <CCol sm="2" style="margin:-30px auto">
                                    <label for="itemsPerPage" class="p-0">Items per page:</label>
                                    <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                                    <option value="10">Show 10</option>
                                    <option value="20">Show 20</option>
                                    <option value="50">Show 50</option>
                                    </select>
                                </CCol>
                            </CRow>
                            <template v-if="Busy == true">
                                    <div class="container text-center">
                                        <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                                    </div>
                            </template>
                            <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredLists" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
                                                
                                <template #VoucherName="{ item }">
                                    <td>
                                    
                                        <label class="custom-12px-500 ml-2">{{ item.name }}</label>
                                    </td>
                                </template>

                                <template #VoucherCode="{ item }">
                                    <td>
                                        <div class="text-center">{{ item.code }}</div>
                                    </td>
                                </template>

                                <template #ValidUntill="{ item }">
                                    <td>
                                        {{ item.validUntil | moment("DD/MM/YYYY") }}
                                    </td>
                                </template>

                                <template #Amount="{ item }">
                                    <td>
                                        <div class="text-center"> {{ item.amount }}</div>
                                    
                                    </td>
                                </template>

                                <template #Description="{ item }">
                                    <td>
                                        {{ item.description }}
                                    </td>
                                </template>

                                <template #Action="{ item }">
                                    <td>
                                        <div class="d-flex">
                                            <label class="custom-border-purple p-20 b-20 text-white mt-1" @click="OpenUpdate(item.id)"><span class="mr-3 ml-3">Edit</span></label>
                                            <img src="../assets/img/delete.png" @click="OpenDelete(item)" style="max-width:30px" class="ml-2">
                                        </div>
                                    </td>
                                </template>
                            </CDataTable>
                        </CCol>
                    </CRow>
                </CCard>

                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isAddVoucher">
                    <div class="p-2 ml-3 mt-3 mr-3">
                        <h3 class="custom-32px-500 text-center font-color-171717">Upload Voucher</h3>
                        <CRow class="mt-3">
                            <div v-if="this.ErrorMessage == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> Error to Add Voucher
                                                </CAlert>
                                            </div>
                            <CCol sm="12" class="m-2">
                                <CCard class="border-16px m-2">
                                    <div class="m-3">
                                        <CRow>
                                            <CCol sm="6">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher Name</h4>
                                                <CInput type="text" v-model="title" placeholder="Get 20 Off Your First Time with AI Interview!"/>
                                            </CCol>
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher Code</h4>
                                                <CInput type="text" v-model="code" placeholder="AIINTERVIEW20"/>
                                            </CCol>
                                            <CCol sm="2">
                                                <h4 class="custom-14px-500 font-inter font-black">Valid Untill</h4>
                                                <CInput type="date" v-model="valid_date" :min="today"/>
                                            </CCol>
    
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Discount</h4>
                                                <CInput type="number" v-model="voucher" placeholder="10"/>
                                            </CCol>

                                            <!-- <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Limit</h4>
                                                <CInput type="text" />
                                            </CCol> -->
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher For</h4>
                                                <v-select v-model="SelectedTypeVoucher" :options="voucherType" label="Name"></v-select>
                                            </CCol>
                                            <CCol sm="12">
    
                                                <h4 class="custom-14px-500 font-inter font-black"> Description/Rules</h4>
                                                <CTextarea type="text" rows="9" placeholder="Subscribe to AI Interview today and enjoy 20 off your first subscribe! Use the voucher code below during checkout to redeem this special offer." class="mb-2" v-model="subtitle"></CTextarea>
                                            </CCol>
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="text-danger mt-5 mr-5">Cancel</label>
                                                    <CButton class="custom-border-purple text-white" @click="SubmitVoucher"><span class="ml-2 mr-2">Publish</span></CButton>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCard>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>


                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isUpdateVoucher">
                    <div class="text-right">
                        <CButton type="button" class="custom-border-purple text-white mr-3 mt-3" @click="toggleUpdateVoucher">
                            <span class="ml-3 mr-3">Back To Home</span>
                        </CButton>
                    </div>
                  
                    <div class="p-2 ml-3 mt-3 mr-3">
                        <h3 class="custom-32px-500 text-center font-color-171717">Update Voucher</h3>
                        <CRow class="mt-3">
                            <div v-if="this.ErrorMessage == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> Error to Update Voucher
                                                </CAlert>
                                            </div>
                            <CCol sm="12" class="m-2">
                                <CCard class="border-16px m-2">
                                    <div class="m-3">
                                        <CRow>
                                            <CCol sm="6">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher Name</h4>
                                                <CInput type="text" v-model="Title" placeholder="Get 20 Off Your First Time with AI Interview!"/>
                                            </CCol>
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher Code</h4>
                                                <CInput type="text" v-model="Code" placeholder="AIINTERVIEW20"/>
                                            </CCol>
                                            <CCol sm="2">
                                                <h4 class="custom-14px-500 font-inter font-black">Valid Untill</h4>
                                                <CInput type="date" v-model="ValidDate"/>
                                            </CCol>
    
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Discount</h4>
                                                <CInput type="number" v-model="Voucher" placeholder="10"/>
                                            </CCol>

                                            <!-- <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Limit</h4>
                                                <CInput type="text" v-model="Limit"/>
                                            </CCol> -->
                                            <CCol sm="4">
                                                <h4 class="custom-14px-500 font-inter font-black">Voucher For</h4>
                                                <v-select v-model="SelectedUpdateType" :options="voucherType" label="Name"></v-select>
                                            </CCol>
                                            <CCol sm="12">
    
                                                <h4 class="custom-14px-500 font-inter font-black"> Description/Rules</h4>
                                                <CTextarea type="text" rows="9" placeholder="Subscribe to AI Interview today and enjoy 20 off your first subscribe! Use the voucher code below during checkout to redeem this special offer." class="mb-2" v-model="SubTitle"></CTextarea>
                                            </CCol>
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="text-danger mt-5 mr-5">Cancel</label>
                                                    <CButton class="custom-border-purple text-white" @click="UpdateVoucher"><span class="ml-2 mr-2">Save</span></CButton>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCard>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
    
                <br /><br /><br />
            </div>
    
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Save Successfully
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>

        <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/Ellipsedelete.png" />
                        <h3 class="custom-18px text-center mt-3">
                            Are you sure want to delete <br /> {{ voucherSession }} ?
                        </h3>
                        <div class="mt-4">
                            <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="DeleteVoucher(sessionDelete)" style="width:100px">Yes</label>
                            <label class="custom-border-purple p-2 text-center mr-2 text-white" @click="CloseDelete()" style="width:100px">Cancel</label>
                        </div>
                    </div>
    
                </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
import _ from "lodash";

Vue.use(Carousel3d);
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");
import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import ToggleCard from '../components/Toggle.vue';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        ToggleCard,
        PulseLoader

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            title: "",
            subtitle: "",
            voucher: "",
            code: "",
            valid_date: "",
            ErrorMessage: false,
            isPopupSuccess: false,

            currentPage: 1,
            itemsPerPage: 10,
            fields: [{
                    key: 'VoucherName'
                },
                {
                    key: 'VoucherCode'
                },
                {
                    key: 'ValidUntill'
                },
                {
                    key: 'Amount'
                },
                {
                    key: 'Description'
                },
                {
                    key: 'Action'
                },
            ],
            voucher: [],
            isAddVoucher: false,
            searchQuery: "",
            Busy: false,
            loading: "",
            color: "",
            size: "",
            isListVoucher: true,
            SelectedTypeVoucher: "",
            voucherType: [],
            isUpdateVoucher: false,
            SelectedUpdateType: {},
            SubTitle: "",
            Name: "",
            Title: "",
            ValidDate: "",
            Voucher: "",
            Limit: "",
            Discount: "",
            VoucherId: 0,
            Description: "",
            isPopupDelete:false

        }
    },
    computed: {
        filteredLists() {
            const query = this.searchQuery.toLowerCase().trim();
            // Filter the list based on the search query and session details
            const filtered = this.voucher.filter(item => {
                const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
                return matchesQuery;
            });
            // Sort the filtered list by name
            return filtered;
        },
        totalItems() {
            return this.filteredLists.length;
        },
        pagedList() {
            // Paginate the filtered list based on currentPage and itemsPerPage
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            return this.filteredLists.slice(startIndex, startIndex + this.itemsPerPage);
        },
        startIndex() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endIndex() {
            return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        }
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {

                this.GetInfoUser();
                this.getListVoucher();
                this.GetListTypeVoucher();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {
        today() {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const dd = String(today.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },
        buttonVoucher() {
            return this.isAddVoucher ? 'Back to Home' : 'Add Voucher';
        },

    },

    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.FullName = this.info.name;
                        this.PhoneNumber = this.info.phone;
                        this.Email = this.info.email;
                        this.Country = this.info.country;
                        this.UserType = this.info.userType;
                        this.AboutUsCandidate = this.info.aboutUsCandidate;
                        this.UserId = this.info.id;
                        this.filePath = this.info.filePath;
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SubmitVoucher() {

            const formData = new FormData();
            formData.append("Id", 0);
            formData.append("Title", this.title);
            formData.append("SubTitle", this.subtitle);
            formData.append("Code", this.code);
            formData.append("Voucher", this.voucher);
            formData.append("ValidDate", this.valid_date);
            formData.append("TypeVoucher", this.SelectedTypeVoucher.Id);

            return this.$API
                .post(this.$InsertVoucher, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {

                        this.isPopupSuccess = true;
                        location.reload();
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },
        UpdateVoucher() {

        const formData = new FormData();
        
        formData.append("Id", this.VoucherId);
        formData.append("Title", this.Title);
        formData.append("SubTitle", this.SubTitle);
        formData.append("Code", this.Code);
        formData.append("Voucher", this.Voucher);
        formData.append("ValidDate", this.ValidDate);
        formData.append("TypeVoucher", this.SelectedUpdateType.Id);

        return this.$API
            .post(this.$InsertVoucher, formData, {
                withCredentials: true,
            })
            .then((response) => {
                if (response.status == 200 && response.data > 0) {

                    this.isPopupSuccess = true;
                    location.reload();
                } else {
                    this.ErrorMessage = true;
                }
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                    this.Error = true;
                    this.Message = error;
                    this.Message = "Error";

                    this.ErrorMessage = true;
                }
            });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        async getListVoucher() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$ListVoucher, {
                    withCredentials: true
                });
                if (response.status === 200) {
                    this.Busy = false;
                    this.voucher = response.data;
                    this.filteredLists = this.voucher;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleAddVoucher() {
            this.isAddVoucher = !this.isAddVoucher;
            this.isListVoucher = !this.isAddVoucher;
        },
        toggleUpdateVoucher() {
            this.isUpdateVoucher = !this.isUpdateVoucher;
            this.isListVoucher = !this.isUpdateVoucher;
        },
        GetListTypeVoucher() {
            try {

                return this.$API
                    .get(this.$GetListTypeUserVoucher)
                    .then((response) => {
                        if (response.status == 200) {
                            this.voucherType = response.data;
                        }
                    });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        OpenUpdate(id) {
            this.jobId = id;
            this.GetVoucherById(id);

            this.isUpdateVoucher = !this.isUpdateVoucher;
            this.isListVoucher = !this.isUpdateVoucher;
        },
        async GetVoucherById(id) {
            try {
                const response = await this.$API.get(this.$GetVoucherByVoucherId + "?id=" + id);
                if (response.status === 200) {
                    this.info = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.VoucherId = this.info.Id;
                        this.Code = this.info.Code;
                        this.Name = this.info.Name;
                        this.SubTitle = this.info.SubTitle;
                        this.Description = this.info.Description;
                        this.Title = this.info.Title;
                        this.ValidDate = this.info.ValidDate ? this.info.ValidDate.split("T")[0] : "";
                        this.Voucher = this.info.Voucher;
                        this.SetupSelectedOption(this.Name);
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SetupSelectedOption() {
            console.log("Setting selected country:", this.Name, this.voucherType);
            this.SelectedUpdateType = _.find(this.voucherType, { Name: this.Name });

            if (!this.SelectedUpdateType) {
                console.warn("Country not found:", this.Name);
            }
        },
        OpenDelete(item) {
            this.sessionDelete = item.id;
            this.voucherSession = item.name;
            this.isPopupDelete = true;
        },
        DeleteVoucher: function(voucherId) {
            const formData = new FormData();

            formData.append("voucherId", voucherId);

            return this.$API
                .post(this.$DeleteVoucher, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupDelete = false;
                        this.getListVoucher();
                    } else {
                        this.Busy = false;
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        CloseDelete() {
            this.isPopupDelete = false;
        },




    }

};
</script>

